const getLastUrlSegment = url => {
  return url.substring(url.lastIndexOf('/') + 1);
};

export default getLastUrlSegment;
